module.exports = __webpack_public_path__ + "img/payment_error.ca2fd6dd.png";